
function redirect(url) {
	if ($.support.pjax && Static.pjax) { if (url == undefined) $.pjax.reload('#dynamic-content'); else $.pjax({ container: '#dynamic-content', url: url }); }
	else { if (url == undefined) location.reload(); else window.location = url; }
}

function load_jquery_ui(callback) {
	if (window.cash) return;
	if ('ontouchstart' in window) nbl.l("/resource/js/jquery-ui.min.js", function () { nbl.l("/resource/js/jquery.ui.touch-punch.min.js", callback); });
	else nbl.l("/resource/js/jquery-ui.min.js", callback);
}

function getFlash(id) {
	var movie = (navigator.appName.indexOf("Microsoft") != -1 ? window : document)[id];
	return movie;
}

function str_TimeLen(sec) {
	var hour = Math.floor(sec / 3600);
	sec -= hour * 3600;

	var min = Math.floor(sec / 60);
	sec -= min * 60;

	return (hour > 0 ? int_Zero(hour) + ':' : '') + int_Zero(min) + ':' + int_Zero(sec);
}

function int_Zero(val) {
	return val < 10 ? '0' + val : val;
}

function str_Numeral(number, word) {
	var cases = [2, 0, 1, 1, 1, 2];
	var titles = word.split('|');
	return number + ' ' + titles[0] + titles[(number % 100 > 4 && number % 100 < 20) ? 3 : cases[Math.min(number % 10, 5)] + 1];
}

function getSelected() {
	if (window.getSelection) return window.getSelection();
	if (document.getSelection) return document.getSelection();
	if (document.selection) return document.selection.createRange().text;
}

function message_getParsed(m) {
	//if (Static.user.id != 1) return m;

	m = m.replace(new RegExp("(http|https|ftp|irc)://([^\\s])+", "igm"), function (data) {
		var t = data.length > 30 ? data.substr(0, 30) + '...' : data;
		return "<a href='" + data + "' target='_blank'>" + t + "</a>";
	});

	return m;
}

function editor_setCursor(ta, s, e) {
	if (!ta) return;
	if (ta.createTextRange) {
		var range = ta.createTextRange();
		range.move("character", s);
		range.select();
	} else if (ta.selectionStart) {
		try {
			ta.setSelectionRange(s, e);
		} catch (error) { console.log(error); }
	}
}

function editor_getCursor(ta) {
	var result = { s: 0, e: 0 };
	if (ta.setSelectionRange) {
		return { s: ta.selectionStart, e: ta.selectionEnd }
	} else if (!document.selection) {
		return false;
	} else if (document.selection && document.selection.createRange) {
		var range = document.selection.createRange();
		var range2 = range.duplicate();
		range2.moveToElementText(ta);
		range2.setEndPoint('EndToEnd', range);
		var s = range2.text.length - range.text.length;
		return { s: s, e: result.s + range.text.length };
	}
	return { s: 0, e: 0 };
}

function editor_apply(ta, s, e) {
	var cursorPos = editor_getCursor(ta);
	var txt_pre = ta.value.substring(0, cursorPos.s);
	var txt_sel = ta.value.substring(cursorPos.s, cursorPos.e);
	var txt_aft = ta.value.substring(cursorPos.e);

	var nuCursorPos = cursorPos.s == cursorPos.e ? cursorPos.s + s.length : String(txt_pre + s + txt_sel + e).length;

	ta.value = txt_pre + s + txt_sel + e + txt_aft;

	editor_setCursor(ta, nuCursorPos, nuCursorPos);

	return false;
}

function getCounter(c, is_c) {
	if (is_c === undefined) is_c = true;
	return is_c ? c : '';
}

function setCounter(id, c, is_delta) {
	var el = $('#count_' + id);
	if (is_delta) c = parseInt(el.text()) + c;
	if (c < 0) c = 0;

	if (c == el.html()) return;
	if (c > 99) c = "*";
	if (c) el.hide().html(c).fadeIn('slow'); else el.html(0).fadeOut('fast');
	$('#user-bar').removeClass('heads-up');
	if ($("#audio-static-player").length) $("#audio-static-player").css('top', '45px');
}

/*--------------------------------------------------------------------------------------------------
	Date functions
--------------------------------------------------------------------------------------------------*/

function date_Full(date) {
	if (typeof date != 'object') date = new Date(date * 1000);
	return int_Zero(date.getHours()) + ':' + int_Zero(date.getMinutes()) + ' ' +
		int_Zero(date.getDate()) + '.' + int_Zero(date.getMonth() + 1) + '.' + date.getFullYear();
}

function date_Full_curr(date) {
	return date_Full(new Date());
}

function date_Time(date) {
	if (typeof date != 'object') date = new Date(date * 1000);
	return int_Zero(date.getHours()) + ':' + int_Zero(date.getMinutes()) + ':' + int_Zero(date.getSeconds());
}

function date_Time_curr() {
	//date = new ;
	return date_Time(new Date());
	//return int_Zero(date.getHours()) + ':' + int_Zero(date.getMinutes()) + ':' + int_Zero(date.getSeconds());
}

function int_Human(val) {
	var ret = '';
	var j = 0;
	val = val + '';
	for (var i = val.length - 1; i >= 0; i--) {
		if (j && j % 3 == 0) ret = ',' + ret;
		ret = val[i] + ret;
		j++;
	}
	return ret;
}

function date_Relative(time, ago, basetime) {
	if (!time) return 'вечность';
	if (ago == undefined) ago = ' назад';

	time = basetime - time;
	if (time == 0) return 'только что';
	if (time < 0) { time = -time; ago = ' в будущем'; }
	if (time < 60) return str_Numeral(time, 'секунд|у|ы|') + ago;

	var l_min = 60;
	var l_hour = l_min * 60;
	var l_day = l_hour * 24;
	var l_month = l_day * 30;
	var l_year = l_month * 12;

	var year = Math.floor(time / l_year); time -= year * l_year;
	var month = Math.floor(time / l_month); time -= month * l_month;
	var day = Math.floor(time / l_day); time -= day * l_day;
	var hour = Math.floor(time / l_hour); time -= hour * l_hour;
	var min = Math.floor(time / l_min); time -= min * l_min;

	if (year) return str_Numeral(year, '|год|года|лет') + ago;
	if (month) return str_Numeral(month, 'месяц||а|ев') + ago;
	if (day) return str_Numeral(day, '|день|дня|дней') + ago;
	if (hour) return str_Numeral(hour, 'час||а|ов') + ago;
	if (min) return str_Numeral(min, 'минут|у|ы|') + ago;
	if (value) return str_Numeral(time, 'секунд|у|ы|') + ago;
}

/*--------------------------------------------------------------------------------------------------
	Sliders
--------------------------------------------------------------------------------------------------*/

(function ($) {
	$.fn.slider = function (container, options) {
		var defaults = {
			title: '',
			inited: true,
			width: 200,
			min: 0,
			max: 100,
			position: false,
			points: true,
			onDrag: function (position) { }
		}

		if (options) {
			options.container = this;
		} else {
			options = $.isPlainObject(container) ? container : { container: container }
		}

		for (var i = 0; i < this.length; i++) {
			if ($(this[i]).data('inited')) {
				$.slider_update_position($(this[i]), options);
			} else {
				$.slider($.extend({}, defaults, options, { container: $(this[i]) }));
			}
		}
	}

	$.slider_update_position = function (slider, options) {
		var opts = $.extend(slider.data(), options);
		opts.container.find('.ui-slider-handle').css('left', Math.round((opts.width - 5) / opts.max * opts.position));
	}

	$.slider = function (options) {
		options.container.data(options);

		options.container.html(
			"<div style='overflow: hidden; padding-top: 3px;' class='ui-slider-bg' title='" + options.title + "'>" +
			"<div style='position: relative; border-top: 1px solid #caced4; width: " + options.width + "px; height: 3px; margin-top: 3px; '>" +
			(options.points ?
				"<div style='background: #caced4; float: left; margin-top: -3px; width: 5px; height: 5px; border-radius: 2px; -webkit-border-radius: 2px;'></div>" +
				"<div class='ui-slider-handle' style=' position: absolute; margin-top: -3px; background: #969daa; width: 5px; height: 5px; border-radius: 2px; -webkit-border-radius: 2px;'></div>" +
				"<div style='background: #caced4; float: right; margin-top: -4px; width: 7px; height: 7px; border-radius: 3px; -webkit-border-radius: 3px;'></div>"
				:
				"<div class='ui-slider-handle' style=' position: absolute; margin-top: -3px; background: #969daa; width: 5px; height: 5px; border-radius: 2px; -webkit-border-radius: 2px;'></div>"
			) +
			"</div>" +
			"</div>");

		var $btn = options.container.find('.ui-slider-handle');

		options.container.find('.ui-slider-bg').mousedown(function (event) {
			if ($(event.target).hasClass('ui-slider-handle')) return;
			var l = event.originalEvent.layerX - 3;
			if (l < 0) l = 0;
			if (l > options.width - 5) l = options.width - 5;
			$btn.css('left', l);
			options.position = l / (options.width - 5) * options.max;
			if (options.connectedWith)
				$(options.connectedWith + '[id!=' + options.container.attr('id') + ']').find('.ui-slider-handle').css('left', l);
			options.onDrag(options.position);
			//$btn.trigger(event);
		});

		if (options.position === false) options.position = (options.max - options.min) / 2;

		$btn.css('left', Math.round((options.width - 5) / options.max * options.position));
		load_jquery_ui(function () { slider_draggable(options); });
	}

	function slider_draggable(options) {
		var $btn = options.container.find('.ui-slider-handle');
		$btn.draggable({
			containment: "parent",
			axis: "x",
			drag: function () {
				var left = parseInt($(this).css('left'));
				options.position = left / (options.width - 5) * options.max;
				options.onDrag(options.position);

				if (options.connectedWith)
					$(options.connectedWith + '[id!=' + options.container.attr('id') + ']').find('.ui-slider-handle').css('left', left);
			},
			stop: function () {
				var left = parseInt($(this).css('left'));
				options.position = left / (options.width - 5) * options.max;
				options.onDrag(options.position);

				if (options.connectedWith)
					$(options.connectedWith + '[id!=' + options.container.attr('id') + ']').find('.ui-slider-handle').css('left', left);
			}
		});
	}
})(jQuery);

/*--------------------------------------------------------------------------------------------------
	Dialogs
--------------------------------------------------------------------------------------------------*/

(function ($) {
	$.dialog_Hide = function (animation) {
		if (animation) $('#dialog').fadeOut('fast', function () { $(this).remove(); });
		else $('#dialog').hide().remove();

		$('#dialog-modal').hide().remove();
	}

	$.fn.dialog = function (options) {
		if ($('#dialog').length) $.dialog_Hide();

		if (options) options.container = this;
		else options = $.isPlainObject(container) ? container : { container: container }

		var defaults = {
			title: '',
			text: '',
			text_after: '',
			fields: {},
			buttons: {},
			values: {},
			action: '',
			method: 'post',
			ajax: false,
			modal: true,
			popup: true,
			width: 350,
			onSuccess: function (data) { },
			onError: function (data) { }
		}

		$.dialog($.extend({}, defaults, options));
	}

	$.dialog = function (options) {
		var fields = [], buttons = [], f, first = 0, i, first_text = 1, file = false;

		if (typeof player_deFocus != 'undefined' && !$.isEmptyObject(options.fields)) player_deFocus();

		for (i in options.fields) {
			f = options.fields[i];
			if (!first) first = i;
			if (f[2] == undefined) f[2] = '';
			switch (f[0]) {
				case 'text':
					fields.push(f[1] + ":<br><input type='text' id='field-" + i + "' name='" + i + "' value='" + f[2] + "'" + (f[3] ? "class='" + f[3] + "'" : "") + (first_text ? ' autofocus' : '') + ">");
					if (first_text) {first_text = 0;}
					break;
				case 'text_placeholder':
					fields.push("<input placeholder='" + f[1] + "' type='text' id='field-" + i + "' name='" + i + "' value='" + f[2] + "'" + (f[3] ? "class='" + f[3] + "'" : "") + (first_text ? ' autofocus' : '') + ">");
					if (first_text) {first_text = 0;}
					break;
				case 'password': fields.push(f[1] + ":<br><input type='password' id='field-" + i + "' name='" + i + "' value='" + f[2] + "'>"); break;
				case 'hidden': fields.push("<input type='hidden' id='field-" + i + "' name='" + i + "' value='" + f[1] + "'>"); break;
				case 'file': fields.push("<br><input type='file' id='field-" + i + "' name='" + i + "' accept='" + f[1] + "'><br><br>" + f[2]); file = true; break;
				case 'textarea': fields.push(f[1] + ":<br><textarea id='field-" + i + "' name='" + i + "'>" + f[2] + "</textarea>"); break;
				case 'select':
					var s = f[1] + ":<br><select id='field-" + i + "' name='" + i + "'>";
					for (var j in f[3]) s += "<option value='" + j + "'" + (f[2] == j ? " selected" : '') + ">" + f[3][j] + "</option>";
					s += "</select>";
					fields.push(s);
					break;
				case 'checkbox': fields.push("<label><input type='checkbox' id='field-" + i + "' name='" + i + "'" + (f[2] == true ? " checked" : '') + ">" + f[1] + "</label>"); break;
			}
		}

		//if (console) console.log(fields);

		if ($.isEmptyObject(options.buttons)) options.buttons = { 'cancel': ['cancel', 'ok'] };
		for (i in options.buttons) {
			f = options.buttons[i];
			switch (f[0]) {
				case 'submit': buttons.push("<input type='submit' onclick='this.form.submited=this.id;' id='field-" + i + "' name='" + i + "' value='" + f[1] + "'>"); break;
				case 'cancel': buttons.push("<input type='button' value='" + f[1] + "' onClick='$.dialog_Hide();'>"); break;
				case 'js': buttons.push("<input type='button' value='" + f[1] + "' onClick='$(\"#dialog\").data().onSuccess(\"" + i + "\");$.dialog_Hide();'>"); break;
			}
		}

		var content = "<form id='dialog-form' method='post'" + (!file ? "" : " enctype='multipart/form-data'") + " action='" + options.action + "'>\
	<div id='dialog-content-top'><div id='dialog-info'></div>" + options.text + (fields.length && options.text ? '<br><br>' : '') + fields.join('<br><br>') + options.text_after + "</div>";
		if (options.ajax) content += "<input type=hidden name='ajax' value='1'>";
		content += "<div id='dialog-content-sub'>" + buttons.join(' ') + "</div></form>";

		var $dialog = $("<div id='dialog'><img src='/resource/image/icon/close-white.png' class='button close' onClick=\"$.dialog_Hide();\">\
	<div class='title'>" + options.title + "</div>\
	<div id='dialog-content'>" + content + "</div>\
	</div>").appendTo(options.container).data(options);
		load_jquery_ui(function () { $dialog.draggable({ handle: '.title' }); });

		if (options.width > $(window).width() - 20) options.width = $(window).width() - 20;
		$('#dialog-form').css({'width': options.width});
		$('#dialog-content-top').css({'max-height': ($(window).height() - 200) + 'px'});
		$('#dialog-content-top input:not([type="checkbox"])').css('width', options.width - 32);

		if (options.popup) {
			if (options.modal) var modal = $("<div id='dialog-modal'></div>").appendTo(options.container)
				.css('width', $(window).width())
				.css('height', $(document).height())
				.on('click', $.dialog_Hide);
			if (typeof modal.fadeTo == 'function') modal.fadeTo(0, 0.7);

			var h = window.innerHeight;
			if (h < 700) h -= 100;
			$dialog.css('position', 'fixed')
				.css('z-index', 100000)
				.css('left', Math.round(($(window).width() - $dialog.width()) / 2.))
				.css('top', Math.round((h - $dialog.height()) / 3.))
		}

		$dialog.show();

		//$('#dialog #field-' + first).focus();

		if (options.ajax) {
			$('#dialog-form').on('submit', function () {
				$('#dialog-content-sub').css('background-image', 'url(/resource/image/icon/ajax.gif)').css('background-repeat', 'no-repeat');
				options = $('#dialog').data();

				/*options.values = { ajax: true }
				for (i in options.fields) options.values[i] = $('#field-' + i).val();
				for (i in options.extra) options.values[i] = $('#' + i).val();
				for (i in options.buttons) options.values[i] = 1;*/
				options.values = $('#dialog-form').serialize();

				$.post($('#dialog').data().action, options.values, function (data) {
					try {
						data = JSON.parse(data);
						if (data.success) {
							$.dialog_Hide(true);
							$('#dialog').data().onSuccess(data);
						} else {
							$('#dialog-info').html("<div class='box-error'><div>" + data.error + "</div></div>").shake();
							$('#dialog').data().onError(data);
						}
					} catch (e) {
						$('#dialog-info').html("<div class='box-error'><div>Неизвестная ошибка. Попробуйте снова.</div></div>");
						console.error(e);
					}
					$('#dialog-content-sub').css('background-image', 'none');
				}).fail(function() {
					$('#dialog-info').html("<div class='box-error'><div>Запрос заблокирован расширением браузера или не работает сеть.</div></div>");
				});
				return false;
			});
		} else {
			if (typeof options.onSubmit == 'function') $('#dialog-form').on('submit', options.onSubmit);
		}
	}
})(jQuery);

function dialog_info(text, title) { $('#static-content').dialog({ title: title ? title : "Уведомление", text: text }); }

//--------------------------------------------------------------------------------------------------

$.fn.tooltip = function (options) {
	if (options) options.container = this;
	else options = $.isPlainObject(container) ? container : { container: container }

	var defaults = {
		text: '',
		arrow: 'top',
		time: 3000
	}

	$.tooltip($.extend({}, defaults, options));
}

$.tooltip = function (options) {
	var $c = $(options.container), $t;

	if ($c.data('tooltip')) return false;
	$c.data('tooltip', true);
	if (options.text == '') options.text = $c.attr('title');

	var pos = $c.offset();

	if (options.arrow) {
		$t = $("<div class='tooltip-a'></div>");
		$t.html("<div class='arrow-" + options.arrow + "'></div><div class='tooltip'>" + options.text + "</div>");
		switch (options.arrow) {
			case 'top': $t.css({ left: pos.left, top: pos.top + $(options.container).height() + 2 }); break;
			case 'bottom': $t.css({ left: pos.left, top: pos.top + $t.height() + 10 }); break;
		}
	} else {
		$t = $("<div class='tooltip'>" + options.text + "</div>");
		$t.css({ left: pos.left, top: pos.top });
	}

	$t.appendTo('body');
	$(document).one('page.clean', function() {$t.remove();});

	$t.css({left : pos.left - $t.width() * 0.5 + $c.width() * 0.5});

	setTimeout(function () { $t.fadeOut('fast', function () { $(this).remove(); $c.data('tooltip', false); }) }, options.time);
}

function renderNotify(key, m, url_click) {
	if (!Static.queue_popup) Static.queue_popup = {};
	key = key.replace(" ", "");

	var popup_remove = function () {
		$('.popup-' + key).slideUp(400, function () {
			var pos = $(this).position(),
				height = $(this).height();
			$.each(Static.queue_popup, function (key2) {
				var cur_popup = $('.popup-' + key2);
				if (pos.top < cur_popup.position().top) cur_popup.css('top', cur_popup.css('top') - height);
			});
			$(this).remove();
		});
		delete Static.queue_popup[key];
	};

	if (Static.queue_popup[key]) {
		clearInterval(Static.queue_popup[key]);
		var popup = $('.popup-' + key);
		popup.html(popup.html() + "<br>" + m)
	} else {
		var top = 45;
		$.each(Static.queue_popup, function (key2) { top += $('.popup-' + key2).height() + 20; });

		var popup = document.createElement('div');
		$(popup).addClass('popup-new-message').addClass('popup-' + key)
			.css('top', top).slideDown()
			.appendTo(document.body).html(m)
			.click(function () { redirect(url_click); queue_popup_clear(); }).show();
	}

	Static.queue_popup[key] = setTimeout(popup_remove, 10000);
	if (Static.user.notify_sound) {
		if (typeof (Storage) !== "undefined") {
			if (!sessionStorage.getItem(key)) {
				notify_soundPlay('/resource/sound/tt.mp3');
				sessionStorage.setItem(key, true);
			}
		} else notify_soundPlay('/resource/sound/tt.mp3');
	}
}

function queue_popup_clear() {
	$('.popup-new-message').hide();
	$.each(Static.queue_popup, function (key) { clearInterval(Static.queue_popup[key]); delete Static.queue_popup[key]; $('.popup-' + key).remove(); sessionStorage.removeItem(key); });
}

//--------------------------------------------------------------------------------------------------

$.fn.inc = function (human) {
	$.inc(this, human);
}
$.inc = function (container, human) {
	var $c = $(container);
	if (!$c || !$c.length) return;
	var i = parseInt($c.html().replace(',', '')) + 1;
	$c.html(human ? int_Human(i) : i);
}

$.fn.shake = function (range) {
	range = range || 16;

	return this.each(function () { shake($(this), range); });

	function shake(element, range) {
		if (range <= 0) {
			element.css('marginLeft', 0);
			return false;
		}

		element.animate({ marginLeft: range + 'px' }, 40, function () {
			element.animate({ marginLeft: -range + 'px' }, 40, function () {
				shake(element, range - 4);
			});
		});
	}
}

//--------------------------------------------------------------------------------------------------

function cookie_set(name, value, time) {
	if (time > 0) {
		var tmp = new Date();
		tmp.setTime(tmp.getTime() + time * 1000);
		document.cookie = name + "=" + encodeURI(value) + "; path=/; expires=" + tmp.toUTCString() + ";";
	} else if (time < 0) {
		document.cookie = name + "=" + encodeURI(value) + "; path=/;";
	} else {
		document.cookie = name + "=" + encodeURI(value) + "; path=/; expires=Wed, 1 Jan 2030 00:00:00 GMT;";
	}
}

function cookie_get(name) {
	var cookie = " " + document.cookie,
		search = " " + name + "=",
		setStr = null,
		offset = 0,
		end = 0;
	if (cookie.length > 0) {
		offset = cookie.indexOf(search);
		if (offset != -1) {
			offset += search.length;
			end = cookie.indexOf(";", offset)
			if (end == -1) {
				end = cookie.length;
			}
			try {
				setStr = decodeURI(cookie.substring(offset, end));
			} catch (ex) {
				console.error(ex);
				setStr = '';
			}
		}
	}
	return setStr;
}

//--------------------------------------------------------------------------------------------------

function array_Shuffle(a) {
	var i, j, t;
	var ret = [];
	for (i in a) ret.push(a[i]);
	i = ret.length;

	while (i) {
		j = Math.floor((i--) * Math.random());
		t = ret[i];
		ret[i] = ret[j];
		ret[j] = t;
	}
	return ret;
}

function player_deFocus() {
	if (typeof mejs != 'undefined' && mejs.players != undefined) {
		for (var playerIndex in mejs.players) {
			mejs.players[playerIndex].hasFocus = false;
		}
	}
}

function player_ratio() {
	if (Static.player) Static.player.setPlayerSize();
}

function notify_soundPlay(file) {
	if ((typeof Static.sound != "undefined")) { Static.sound.play(); }
	else {
		Static.sound = document.createElement('audio');
		Static.sound.setAttribute('src', file);
		Static.sound.setAttribute('autoplay', 'autoplay');
		Static.sound.addEventListener("load", function () { Static.sound.play(); }, true);
	}
}

function user_getLink(user) {
	var c = { 0: 'adm', 10: 'adm', 1: 'mod', 2: 'mod-series', 3: 'mod-series', '-1': '', '-3': 'user-deleted' };
	return "<a href='" + Static.server + "/people/" + user.u_id + "' class='" + c[user.u_type] + "'>" + (user.account_vip == 1 || user.account_vip == 3 ? "<span class='gold' title='VIP-Пользователь'>&#9733;</span> " : '') + user.u_login + "</a>";
}

function user_getAvatar(user, size) {
	if (size == undefined) size = 28;
	if (user.avatar) {
		var dir = "https://image.krasview.ru/user/" + Math.floor(user.u_id / 1000) + "/" + user.u_id + "/",
			avatar = user.avatar.split(':'),
			actual_size = window.devicePixelRatio > 1 ? 96 : 48,
			ava = dir + avatar[0] + "_" + actual_size + ".jpg" + (avatar[1] ? "?v=" + avatar[1] : "")
	} else var ava = "/resource/image/icon/user.svg";

	return "<div class='user-small'><div class='avatar'><a href='/people/" + user.u_id + "'><img src='" + ava + "' height='" + size + "' width='" + size + "' alt='аватар'></a></div>";
}

var transliterate = (
	function () {
		// ГОСТ 7.79-2000
		var
			rus = "щ  ш  ч  ц  ю  я  ё  ж  ы  э а б в г д е з и й к л м н о п р с т у ф х".split(/ +/g),
			eng = "shh sh ch cz yu ya yo zh y e a b v g d e z i j k l m n o p r s t u f x".split(/ +/g)
			;
		return function (text, engToRus) {
			if (!text) return '';
			text = text.replace(/[ьъ]/gi, "");
			text = text.replace(/[^а-яёa-z1-9 -]/gi, "");
			text = text.replace(/ /gi, "_");
			for (var x = 0; x < rus.length; x++) {
				text = text.split(engToRus ? eng[x] : rus[x]).join(engToRus ? rus[x] : eng[x]);
				text = text.split(engToRus ? eng[x].toUpperCase() : rus[x].toUpperCase()).join(engToRus ? rus[x].toUpperCase() : eng[x].toUpperCase());
			}
			return text;
		}
	}
)();

function e(text, args) {
	args.forEach(function (v, k) { text = text.replace(":" + v, k); });
	return text;
}

function text_backup(key, text) {
	cookie_set('backup_' + key, text, 86400);
}

function backup(el, key) {
	el[0].onpaste = function(e) { text_backup(key, el.val()); };
	el[0].onchange = function(e) { text_backup(key, el.val()); };
	el[0].onkeyup = function(e) { text_backup(key, el.val()); };
	if (el.val() == '') el.val(cookie_get('backup_' + key));
}

// Throttle function (http://bit.ly/1eJxOqL)
function throttle(fn, threshhold, scope) {
	threshhold || (threshhold = 250);
	var previous, deferTimer;
	return function () {
		var context = scope || this,
			current = Date.now(),
			args = arguments;
		clearTimeout(deferTimer);
		if (previous && current < previous + threshhold) {
			deferTimer = setTimeout(function () { previous = current; fn.apply(context, args); }, threshhold);
		} else {
			previous = current;
			fn.apply(context, args);
		}
	};
}

(function (window, document) {
	'use strict';
	// Main function definition
	function headsUp(selector, options) {
		this.selector = document.querySelector(selector);
		this.options = $.extend({}, this.defaults, options);;
		this.init();
	}

	// Overridable defaults
	headsUp.prototype = {
		defaults: {
			delay: 300,
			sensitivity: 20
		},

		// Init function
		init: function (selector) {
			var self = this,
				options = self.options,
				selector = self.selector,
				oldScrollY = -1,
				winHeight;

			// Resize handler function
			function resizeHandler() {
				winHeight = window.innerHeight;
				return winHeight;
			}

			// Scroll handler function
			function scrollHandler(init) {
				// Scoped variables
				var newScrollY = window.pageYOffset,
					docHeight = document.body.scrollHeight,
					pastDelay = newScrollY > options.delay,
					goingDown = newScrollY > oldScrollY,
					fastEnough = newScrollY < oldScrollY - options.sensitivity,
					rockBottom = newScrollY < 0 || newScrollY + winHeight >= docHeight;

				// Where the magic happens
				if (pastDelay && goingDown && oldScrollY !== -1) {
					$(selector).addClass('heads-up');
					if ($("#audio-static-player").length) $("#audio-static-player").css('top', '0');
				} else if (!goingDown && fastEnough && !rockBottom || !pastDelay) {
					if ($("#audio-static-player").length) $("#audio-static-player").css('top', '45px');
					$(selector).removeClass('heads-up');
				}

				// Keep on keeping on
				oldScrollY = newScrollY;
			}

			// Attach listeners
			if (selector) {
				// Trigger initial resize
				resizeHandler();

				// Resize function listener
				window.addEventListener('resize', throttle(resizeHandler), false);

				// Scroll function listener
				window.addEventListener('scroll', throttle(scrollHandler, 100), false);
				window.addEventListener('touchmove', throttle(scrollHandler, 100), false);
			}
		}
	};

	window.headsUp = headsUp;
})(window, document);

$.fn.infinity = function (options) {
	if (options) options.container = this;
	else options = $.isPlainObject(container) ? container : { container: container }

	var defaults = {
		margin: 100,
		max_page: 0,
		loader: "<div id='loader'><img src='/resource/image/icon/ajax.gif'></div>"
	}

	$.infinity($.extend({}, defaults, options));
}

$.infinity = function (options) {
	var page = 2, finished = true;

	$(window).scroll(function () {
		if ($(window).scrollTop() + $(window).height() >= $(document).height() - options.margin && finished) {
			if (options.max_page && page > options.max_page) return;

			finished = false;

			window.setTimeout(function () {
				if (options.loader) options.container.append(options.loader);
				else $('div#loader').show();
				$.ajax({
					url: options.url + page,
					success: function (data) {
						if (options.loader) $('div#loader').remove(); else $('div#loader').hide();
						if (data) {
							$(options.container).append(data);
							page++;
							finished = true;
						}
					}
				});
			}, 200);
		}
	});
}

$.fn.onLongPress = function(callback) {
	onLongPress(this, callback);
}
function onLongPress(element, callback) {
	let timer;

	element.on('touchstart', (e) => {
	  timer = setTimeout(() => {
		timer = null;
		callback(e);
	  }, 500);
	});

	function cancel() {
	  clearTimeout(timer);
	}

	element.on('touchend', cancel);
	element.on('touchmove', cancel);
}

(function ($, window, document) {
	var contextMenu = null;
	function context(element, options) {
		this.element = element;
		this.options = $.extend({}, this.defaults, options);
		this.init();
	}

	// Overridable defaults
	context.prototype = {
		defaults: {
			button: true,
			context: false
		},
		init: function() {
			var t = this;
			if (!contextMenu) {
				contextMenu = $('<div class="contextmenu"></div>').appendTo($('body')).hide();
				$(document).on('click touchstart', function(e) {
					if ($(e.target).hasClass('contextmenu-item')) {
						return true;
					}
					contextMenu.hide();
				})
			}

			if (t.options.context || Static.mobile) {
				t.element.on('contextmenu', function(e) {
					t.renderContextMenu(e.currentTarget, {x: e.pageX-1, y: e.pageY-1});
					return false;
				});
			}

			if (t.options.button) {
				t.buttonEnable();
			}

			// render context menu on long touch
			t.element.onLongPress(function(e) {t.renderContextMenu(e.currentTarget, {x: e.pageX-1, y: e.pageY-1}); return false;});
		},
		hideContextMenu: function() {
			contextMenu.hide();
		},
		getContextMenu: function() {
			return contextMenu;
		},
		buttonEnable: function() {
			var t = this, button = $('<span class="settings"><i class="i-cog"></span>');
			t.element.append(button);
			t.element.find('.settings').on('click', function(e) {
				t.renderContextMenu(e.currentTarget.parentElement, {x: e.pageX-1, y: e.pageY-1});
				return false;
			});
		},
		addItems: function(items) {
			this.options.items = this.options.items.concat(items);
		},
		renderContextMenu: function(target, par) {
			var t = this, html = '',
				items = par.options ? par.options : t.options.items;

			for (var i = 0, il = items.length; i < il; i++) {
				if (items[i].isSeparator) {
					html += '<div class="contextmenu-separator"></div>';
				} else if (items[i].title) {
					html += '<div class="contextmenu-title">' + items[i].title + '</div>';
				} else {
					var rendered = items[i].render(target);

					// render can return null if the item doesn't need to be used at the moment
					if (rendered != null) {
						html += '<div class="contextmenu-item" data-itemindex="' + i + '">' + rendered + '</div>';
					}
				}
			}

			// position and show the context menu
			contextMenu.html(html).show();

			if (par.x) {
				contextMenu.css({top:par.y, left:par.x});
				if ($(window).width() < par.x + contextMenu.width()) contextMenu.css({left: par.x - contextMenu.width()});
			}

			// bind events
			contextMenu.find('.contextmenu-item').each(function() {
				// which one is this?
				var $dom = $(this),
					itemIndex = parseInt($dom.data('itemindex'), 10),
					item = items[itemIndex];

				// bind click action
				$dom.on('click', function() {
					// perform click action
					if (typeof item.click != 'undefined')
						item.click(target);

					// close
					t.hideContextMenu();
				});
			});

			if (typeof this.options.callback != 'undefined') this.options.callback();
		}
	};

	window.context = context;
})(jQuery, window, document);

function utf8_to_cp1251(s) {
	let L = '', len = s.length;
	for (let i = 0; i < len; i++) {
		let char = s.charAt(i);
		let ord = s.codePointAt(i), shift = -1;
		if (ord > 0xFFFF) i++;

		if (ord < 128) shift = 0;
		else if (ord > 159 && ord < 188) shift = 0;//1;
		else if (ord > 1031 && ord < 1104) shift = 0;//848;
		else if (ord > 1103 && ord < 1108) shift = 0;//921;

		if (!shift) L += char;
		else {
			L += '&#' + ord + ';';
		}
	}

	return L;
}

/*--------------------------------------------------------------------------------------------------
	Playlist
--------------------------------------------------------------------------------------------------*/

function playlist_messageShow(contextMenu, type, message) {
	contextMenu.html("<div class='" + type + "' style='margin-bottom:0;'><div>" + message + "</div></div>").show();
	window.setTimeout(function () {
		contextMenu.hide();
	}, 5000);
}

function playlist_renderList(contextMenu, v_id) {
	$.get('/ajax.php?mode=playlist_list&v_id=' + v_id, function(data) {
		if (data.indexOf('{"error"') === 0) {
			data = JSON.parse(data);
			playlist_messageShow(contextMenu, "box-error", data.error);
			return;
		}

		contextMenu.html(data).show();
		contextMenu.find('.contextmenu-item').on('click', function() {
			var $dom = $(this),
				playlist_id = parseInt($dom.data('itemindex'), 10);
			if (!playlist_id) {
				playlist_add(v_id, contextMenu);
			} else if (playlist_id < 0) {
				$.ajax({url: '/ajax.php?mode=playlist_video_del', data: {playlist_id: -playlist_id, video_id: v_id}, type: 'POST', success: function() {
					playlist_messageShow(contextMenu, "box-ok", "Видео удалено из плейлиста");
				}});
			} else {
				$.getJSON("/ajax.php?mode=playlist_video_add&video_id=" + v_id + "&playlist_id=" + playlist_id, function(data) {
					if(data.success) {
						playlist_messageShow(contextMenu, "box-ok", "Видео успешно добавлено в плейлист");
					} else if(data.error) {
						playlist_messageShow(contextMenu, "box-error", data.error);
					} else {alert('Что-то пошло не так. Попробуйте позже.');}
				});
			}
		});
	});
}

function playlist_add(video_id, contextMenu) {
	if (!video_id) $('#audio-menu').hide();

	$('#static-content').dialog({
		title: 'Добавить плейлист',
		fields: {
			'title': ['text','Название','']
		},
		buttons: {
			'save' : ['submit','Добавить'],
			'cancel' : ['cancel','Отмена']
		},
		action: video_id ? '/ajax.php?mode=playlist_add&video_id=' + video_id : '/audio?mode=ajax_playlist_add',
		method: 'post',
		ajax: true,
		onSuccess: function(data) {
			if (video_id) playlist_messageShow(contextMenu, "box-ok", "Создан плейлист");
			else if (data.id) audio_renderPlaylist(data);
		}
	});

	return false;
}

function copyToClipboard(id) {
	var copyText = document.getElementById(id);
	copyText.select();
	copyText.setSelectionRange(0, 99999); // For mobile devices
	navigator.clipboard.writeText(copyText.value);
	//dialog_info("Скопировано");
	renderNotify("Уведомление", "<div class='clear'><h1>Скопировано</h1></div>", '');
	return false;
}